<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #DETAILS="{ visible, params }">
      <Tracker v-if="visible" :statusId="params.row.airway_number"></Tracker>
    </template>
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('n_process')" name="NO" />
        <TabPane :label="$t('y_process')" name="YES" />
        <TabPane :label="$tz('退件,异常')" name="0" />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  getReturn,
  submitPlan,
  getVirtualReturn,
  updatePlan,
  getReturnPlan,
  instruct,
  deleteAbnormalPackage
} from "@/api/storage/return";
import { getCompanies, getAllClient } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import { getWarehouse } from "@/api/storage/warehouse";
import { getUser } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getKeysType } from "@/api/public";
import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";
import { getAllService } from "@/api/user/internal";
export default {
  name: "returnOrder",
  components: {
    cTable,
    Tracker
  },
  async mounted() {
    let selData = await this.$sel.getData([
      "RETURN_DATE_TYPE",
      "OMS_RETURN_KEYWORDS_TYPE",
      "OMS_RETURN_STATUS",
      "OMS_RETURN_PLAN"
    ]);
    let warehouseData = (await getWarehouse({ is_oversea: "YES" })).data.payload
      .rows;
    this.pickingType = this.$sel.ToObj(selData["OMS_RETURN_PLAN"]);
    this.bagType = this.$sel.ToObj(selData["OMS_RETURN_STATUS"]);
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouse_id") item.options = warehouseData;
      if (item.key === "dateType") item.options = selData["RETURN_DATE_TYPE"];
      if (item.key === "keywordsType")
        item.options = selData["OMS_RETURN_KEYWORDS_TYPE"];
      if (item.key === "complyStatus")
        item.options = selData["OMS_RETURN_STATUS"];
      if (item.key === "plan") item.options = selData["OMS_RETURN_PLAN"];
      if (item.key === "service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
    this.modals.plan.fields.forEach(it => {
      if (it.key === "plan") {
        let arr = selData["OMS_RETURN_PLAN"].slice(
          1,
          selData["OMS_RETURN_PLAN"].length
        );

        it.options = arr.filter(t => t.value != 5);
      }
    });
    this.modals.virtualWarehouse.fields.forEach(it => {
      if (it.key === "warehouse_id") {
        it.options = warehouseData;
      }
    });
  },
  methods: {
    handleTab() {
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    }
  },
  data() {
    let pickingSel = [
        { label: this.$t("Wait_Picking"), value: 2 },
        { label: this.$t("Picking"), value: 3 },
        { label: this.$t("stayDone"), value: 4 },
        { label: this.$t("completed"), value: 5 },
        { label: this.$t("agentProcessed"), value: 6 }
      ],
      pickingType = {
        1: { label: this.$t("Pending"), value: 1 },
        2: { label: this.$t("Wait_Picking"), value: 2 },
        3: { label: this.$t("Picking"), value: 3 },
        4: { label: this.$t("stayDone"), value: 4 },
        5: { label: this.$t("completed"), value: 5 },
        6: { label: this.$t("agentProcessed"), value: 6 }
      },
      bagSel = [
        { label: this.$t("original_shelves"), value: 1 },
        { label: this.$t("unpack_sheves"), value: 2 },
        { label: this.$t("self_mention"), value: 3 },
        { label: this.$t("destroy"), value: 4 },
        { label: this.$t("system_shelf"), value: 5 },
        { label: this.$t("sell"), value: 6 }
      ],
      bagType = [
        { label: this.$t("no_plan"), value: 0 },
        { label: this.$t("original_shelves"), value: 1 },
        { label: this.$t("unpack_sheves"), value: 2 },
        { label: this.$t("self_mention"), value: 3 },
        { label: this.$t("destroy"), value: 4 },
        { label: this.$t("system_shelf"), value: 5 },
        { label: this.$t("sell"), value: 6 }
      ];
    return {
      pickingType: {},
      bagType: {},
      tabName: "NO",
      methods: {
        list: params => {
          if (this.tabName == "0") {
            params["is_exception"] = "YES";
          } else params["submitted"] = this.tabName;
          return getReturn(params);
        },
        getKeysType,
        submitPlan,
        getVirtualReturn,
        updatePlan,
        getReturnPlan,
        instruct,
        deleteAbnormalPackage
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        instruct: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("instruct", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("TT下架指令"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("订单号码"),
              placeholder() {
                return this.$tz("订单号码");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 5 }
              }
            }
          ]
        },
        virtualWarehouse: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = data.airway_number.trim();
              this.$page
                .handleRequestMethods("getVirtualReturn", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("Bagging"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              plan: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ],
              warehouse_id: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { plan: 24 }, { warehouse_id: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              }
            },
            {
              name: () => this.$t("plan"),
              key: "plan",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("plan");
              },
              options: [],
              methods: {
                async list({ field }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE_PLAN"]))
                    .data.payload["VIRTUAL_WAREHOUSE_PLAN"];
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("warehouseName"),
              key: "warehouse_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName");
              },
              options: [],
              config: { label: "title", value: "id" }
              // methods: {
              //   async list({ field }) {
              //     let res = (await getSelectType(["VIRTUAL_WAREHOUSE"])).data
              //       .payload["VIRTUAL_WAREHOUSE"];
              //     field.options = res;
              //     this.$forceUpdate();
              //   },
              // },
            }
          ]
        },
        updatePlan: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = data.airway_number.trim();
              this.$page
                .handleRequestMethods("updatePlan", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("modify") + this.$t("process_status"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              status: [
                {
                  required: true,
                  trigger: "change"
                }
              ]
              // warehouse_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     trigger: "change"
              //   }
              // ]
            }
          },
          grid: [
            { airway_number: 24 },
            { status: 24 }
            // { warehouse_id: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("exlType");
              },
              options: [],
              methods: {
                async list({ field }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE_STATUS"]))
                    .data.payload["VIRTUAL_WAREHOUSE_STATUS"];
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("warehouseName"),
              key: "warehouse_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName");
              },
              options: [],
              methods: {
                async list({ field }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE"])).data
                    .payload["VIRTUAL_WAREHOUSE"];
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            }
          ]
        },
        plan: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = data.airway_number.trim().split("\n");
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("sell"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              plan: [
                {
                  required: true,
                  type: "number",
                  trigger: "change"
                }
              ],
              status: [
                {
                  required: true,
                  type: "string",
                  message: "is unique cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { plan: 24 }, { remarks: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              }
            },
            {
              name: () => this.$t("plan"),
              key: "plan",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("plan");
              },
              options: [],
              default: () => {
                console.log(this.$refs["table"].getModal("plan").type);
                return this.$refs["table"].getModal("plan").type == "submitPlan"
                  ? 6
                  : "";
              },
              disabled: () => {
                return this.$refs["table"].getModal("plan").type == "submitPlan"
                  ? true
                  : false;
              }
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 600
            }
          },
          footer: { show: () => false }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("type");
            },
            options: []
            // methods: {
            //   async list({ field, searchForm }) {
            //     let res = (await getSelectType(["RETURN_DATE_TYPE"])).data
            //       .payload["RETURN_DATE_TYPE"];
            //     field.options = res;
            //     searchForm["dateType"] = res[0].value;
            //     this.$forceUpdate();
            //   },
            // },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getCompanies()).data.payload;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            options: [],
            config: { label: "title", value: "id" }
          },
          {
            key: "plan",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("plan");
            },
            options: [],
            show: () => this.tabName == "YES"
          },
          {
            key: "complyStatus",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            options: [],
            show: () => this.tabName == "YES"
          },
          {
            key: "service_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            config: { label: "account", value: "id" },
            options: []
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                let res = (await getAllService()).data.payload;
                let arr = [5];
                let data = [];
                arr.forEach(item => {
                  data = data.concat(res[item]);
                });
                field.options = data;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "return",
            component: "Select",
            placeholder() {
              return this.$t("DTO");
            },
            options: [
              {
                label: this.$t("YES"),
                value: "YES"
              },
              {
                label: this.$t("NO"),
                value: "NO"
              }
            ]
          },
          {
            key: "country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryCode");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            methods: {
              async list({ field }) {
                let res = (await getCountry()).data.payload;
                field.options = res.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywordsType",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: false,
            options: []
            // methods: {
            //   list({ field, searchForm }) {
            //     this.$page
            //       .handleRequestMethods("getKeysType", "PACKAGE")
            //       .then((res) => {
            //         searchForm[field.key] = res.payload[0].value;
            //         field.options = res.payload;
            //       });
            //   },
            // },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("Bagging"),
              type: "virtualWarehouse",
              fnName: "virtualWarehouseFun",
              bind: {
                type: "success"
              },
              id: 939
            },
            {
              name: () => this.$t("modify") + this.$t("process_status"),
              type: "updatePlan",
              fnName: "updatePlanFun",
              bind: {
                type: "success"
              },
              id: 940
            },
            // {
            //   name: () => this.$t("sell"),
            //   type: "submitPlan",
            //   fnName: "sell",
            //   bind: {
            //     type: "warning"
            //   },
            //   show: () => this.tabName != "YES"
            // },
            {
              name: () => this.$t("order_submit") + this.$t("plan_t"),
              type: "getReturnPlan",
              fnName: "sell",
              bind: {
                type: "warning"
              },
              // show: () => this.tabName != "YES",
              id: 1141
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("异步,导出"),
              type: "exportSync",
              sync: true,
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$tz("TT下架指令"),
              type: "instruct",
              fnName: "instruct",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("批量,删除"),
              type: "deleteAbnormalPackage",
              fnName: "deleteAbnormalPackage",
              bind: {
                type: "error"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            deleteAbnormalPackage() {
              this.$Modal.confirm({
                title: this.$tz("批量,删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "deleteAbnormalPackage",
                    { ids: this.selectAll.map(t => t.id) },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            instruct() {
              this.getModal("instruct").open();
            },
            updatePlanFun() {
              this.getModal("updatePlan").open();
            },
            virtualWarehouseFun() {
              this.getModal("virtualWarehouse").open();
            },
            sell({ field }) {
              this.getModal("plan").type = field.type;
              this.getModal("plan").open(null, function() {
                this.setTitle(
                  this.type == "submitPlan"
                    ? this.$t("sell")
                    : this.$t("order_submit") + this.$t("plan_t")
                );
              });
            },
            export({ searchForm, field }) {
              !field.sync && this.exportExc();
              field.sync &&
                this.handleRequestMethods(
                  "list",
                  Object.assign(searchForm, { export: 1 }),
                  false,
                  true
                ).then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "center",
          header: {
            copy: true //头部复制
          },
          fixed: "left",
          component: "Button",
          copy: true,
          width: 150,
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showDetails").setTitle(row.airway_number);
              this.$page.getModal("showDetails").open({ row });
            }
          }
        },
        {
          name: () => this.$t("DTO"),
          key: "return",
          width: 110,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("bagCode"),
          key: "package_number",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("bagTime"),
          key: "package_time",
          align: "center",
          width: 160
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          header: {
            copy: true //头部复制
          },
          width: 120,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "center",
          minWidth: 140,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("service"),
          key: "service_name",
          align: "left",
          minWidth: 80,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 80
        },
        {
          name: () => this.$t("plan"),
          key: "plan",
          align: "center",
          methods: {
            render: ({ value }) => {
              return this.$sel.keyMap(this.pickingType, value);
            }
          },
          minWidth: 80,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("process_status"),
          key: "complyStatus",
          align: "center",
          minWidth: 100,
          methods: {
            render: ({ value }) => {
              return this.$sel.keyMap(this.bagType, value);
            }
          },
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("customer process time"),
          key: "plan_time",
          align: "center",
          minWidth: 100,
          width: 160,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("return day"),
          key: "returnTime",
          align: "center",
          minWidth: 80,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$tz("下架指令日期"),
          key: "instruct_time",
          minWidth: 140,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("skuName"),
          key: "title",
          align: "left",
          minWidth: 120,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("HSCode"),
          key: "description",
          align: "left",
          minWidth: 120,
          show: () => this.tabName != "0"
        },
        {
          name: () => this.$t("Customer service Handler"),
          key: "service_name_plan",
          align: "center",
          show: () => this.tabName == "YES",
          minWidth: 80
        },
        {
          name: () => this.$t("status_operator"),
          key: "operator_name",
          align: "center",
          minWidth: 80
        },
        {
          name: () => this.$t("operation") + this.$t("time"),
          key: "warehouse_time",
          align: "center",
          show: () => this.tabName == "YES",
          width: 150
        }
      ]
    };
  }
};
</script>
